"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visible = void 0;
var visible = function (_a) {
    var screenClass = _a.screenClass, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    // if (screenClass === 'xxl') return xxl;
    if (screenClass === 'xl')
        return xl;
    if (screenClass === 'lg')
        return lg;
    if (screenClass === 'md')
        return md;
    if (screenClass === 'sm')
        return sm;
    return xs;
};
exports.visible = visible;
exports.default = exports.visible;
//# sourceMappingURL=style.js.map